"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[683],{

/***/ 9797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FadeinText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hook_useShowAnimation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




function FadeinText(param) {
    let { duration =1500 , text  } = param;
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const showAnimation = (0,hook_useShowAnimation__WEBPACK_IMPORTED_MODULE_2__/* .useShowAnimation */ .H)(ref);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("transition-opacity ", {
                "opacity-0": !showAnimation
            }, {
                "opacity-100": showAnimation
            }),
            style: {
                transitionDuration: "".concat(duration, "ms")
            },
            children: text
        })
    });
}


/***/ }),

/***/ 8683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VideoCarouselSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_animation_fadein_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9797);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2606);
/* harmony import */ var _components_vimeo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9972);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7524);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(608);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);







function VideoCarouselSection(param) {
    let { data: { videos  }  } = param;
    const [playingVideoIndex, setPlayingVideoIndex] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0);
    const [thumbnails, setThumbnails] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const [canScrollRight, setCanScrollRight] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [canScrollLeft, setCanScrollLeft] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [preset, setPreset] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null);
    const galleryRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const videoUrls = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>{
        return videos.map((video)=>video.vimeoUrl);
    }, [
        videos
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        const fetchThumbnails = async ()=>{
            const thumbnailPromises = videoUrls.map(async (url)=>{
                const response = await fetch("https://vimeo.com/api/oembed.json?url=".concat(url));
                const data = await response.json();
                return data.thumbnail_url;
            });
            const results = await Promise.all(thumbnailPromises);
            setThumbnails(results);
        };
        fetchThumbnails();
    }, [
        videoUrls
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        const updateScrollState = ()=>{
            const gallery = galleryRef.current;
            if (gallery) {
                setCanScrollRight(gallery.scrollWidth > gallery.clientWidth + gallery.scrollLeft);
                setCanScrollLeft(gallery.scrollLeft > 0);
            }
        };
        updateScrollState();
        const gallery = galleryRef.current;
        gallery === null || gallery === void 0 ? void 0 : gallery.addEventListener("scroll", updateScrollState);
        window.addEventListener("resize", updateScrollState);
        return ()=>{
            gallery === null || gallery === void 0 ? void 0 : gallery.removeEventListener("scroll", updateScrollState);
            window.removeEventListener("resize", updateScrollState);
        };
    }, [
        thumbnails
    ]);
    const scrollRight = ()=>{
        const gallery = galleryRef.current;
        if (gallery) {
            gallery.scrollBy({
                left: 200,
                behavior: "smooth"
            });
        }
    };
    const scrollLeft = ()=>{
        const gallery = galleryRef.current;
        if (gallery) {
            gallery.scrollBy({
                left: -200,
                behavior: "smooth"
            });
        }
    };
    const playingVideo = videos[playingVideoIndex];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_4__/* .ContainerSize.wide */ .B.wide,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "lg:grid grid-cols-12 gap-1.5 md:gap-6 items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-start-2 col-span-6 rounded-xl md:rounded-3xl overflow-hidden",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_vimeo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            url: playingVideo.vimeoUrl,
                            preset: preset
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-4 lg:mt-0 col-start-2 lg:col-start-8 col-span-10 lg:col-span-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-blue-800 text-22 leading-130 lg:text-35 lg:leading-130 font-bold",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_animation_fadein_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    text: playingVideo.title
                                })
                            }),
                            playingVideo.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "prose image-text mt-4",
                                dangerouslySetInnerHTML: {
                                    __html: playingVideo.description
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:grid grid-cols-12 gap-1.5 md:gap-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-start-2 col-span-6 mt-8 lg:mt-3 relative",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        ref: galleryRef,
                        className: "flex items-start gap-x-2 overflow-x-auto scrollbar-hide",
                        children: [
                            thumbnails.map((imgSrc, index)=>{
                                const video = videos[index % videos.length];
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: "shrink-0 w-32 text-left",
                                    onClick: ()=>{
                                        setPreset("thumbnail");
                                        setPlayingVideoIndex(index);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: imgSrc,
                                                    alt: video.title,
                                                    className: "rounded cursor-pointer"
                                                }),
                                                playingVideoIndex === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute inset-0 rounded bg-iceblue-500 text-white text-15 font-bold uppercase bg-opacity-90 flex items-center justify-center",
                                                    children: "Playing"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-blue-800 text-17 leading-160 mt-4 line-clamp-2",
                                            children: video.thumbnailTitle || video.title
                                        })
                                    ]
                                }, index);
                            }),
                            canScrollRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute right-0 top-0 bg-gradient-to-r from-transparent to-white w-32 h-[72px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "absolute right-0 top-4 bg-white rounded-full w-10 h-10 flex justify-center items-center shadow",
                                        onClick: scrollRight,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            className: "w-8 h-8"
                                        })
                                    })
                                ]
                            }),
                            canScrollLeft && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute left-0 top-0 bg-gradient-to-l from-transparent to-white w-32 h-[72px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "absolute left-0 top-4 bg-white rounded-full w-10 h-10 flex justify-center items-center shadow",
                                        onClick: scrollLeft,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: "w-8 h-8"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useShowAnimation; }
/* harmony export */ });
/* harmony import */ var _useOnScreen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4013);

function useShowAnimation(ref) {
    const [, enterCount] = (0,_useOnScreen__WEBPACK_IMPORTED_MODULE_0__/* .useOnScreen */ .R)(ref);
    const showAnimation = enterCount >= 1;
    return showAnimation;
}


/***/ }),

/***/ 13:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function ChevronLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronLeftIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 7524:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronRightIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);